import type { DrawerConfig } from '@/features/drawer/types/DrawerConfig';
import type { Theme } from '@mui/material';
import { DRAWER_INDEX } from '@/features/drawer/constants/drawerIndex';
import { DrawerAnchor } from '@/features/drawer/enums/DrawerAnchor';
import { DrawerSize } from '@/features/drawer/enums/DrawerSize';
import { Drawers } from '@/features/drawer/enums/Drawers';
import { darkTheme } from '@/styles/theme/darkTheme/darkTheme';

export const PartyControlDrawerConfig: DrawerConfig = {
  theme: darkTheme as Theme,
  size: DrawerSize.ExtraSmall,
  anchor: DrawerAnchor.Right,
  behavior: {
    isHeaderOffsetEnabled: true,
  },
  styles: {
    body: {
      zIndex: DRAWER_INDEX + 10,
    },
    common: {
      zIndex: DRAWER_INDEX + 10,
      background: darkTheme.palette?.background?.navigation,
    },
  },
  router: {
    allowedRoutes: ['/party-details/'],
    drawerParam: Drawers.PartyControl,
  },
};
